module.exports = __webpack_public_path__ + "img/emo_09.75477f1b.png";